"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseLicenseCompactUpdateDto = instanceOfNurseLicenseCompactUpdateDto;
exports.NurseLicenseCompactUpdateDtoFromJSON = NurseLicenseCompactUpdateDtoFromJSON;
exports.NurseLicenseCompactUpdateDtoFromJSONTyped = NurseLicenseCompactUpdateDtoFromJSONTyped;
exports.NurseLicenseCompactUpdateDtoToJSON = NurseLicenseCompactUpdateDtoToJSON;
exports.NurseLicenseCompactUpdateDtoToJSONTyped = NurseLicenseCompactUpdateDtoToJSONTyped;
/**
 * Check if a given object implements the NurseLicenseCompactUpdateDto interface.
 */
function instanceOfNurseLicenseCompactUpdateDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('abbreviation' in value) || value['abbreviation'] === undefined)
        return false;
    if (!('jurisdictions' in value) || value['jurisdictions'] === undefined)
        return false;
    return true;
}
function NurseLicenseCompactUpdateDtoFromJSON(json) {
    return NurseLicenseCompactUpdateDtoFromJSONTyped(json, false);
}
function NurseLicenseCompactUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'abbreviation': json['abbreviation'],
        'jurisdictions': json['jurisdictions'],
    };
}
function NurseLicenseCompactUpdateDtoToJSON(json) {
    return NurseLicenseCompactUpdateDtoToJSONTyped(json, false);
}
function NurseLicenseCompactUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'abbreviation': value['abbreviation'],
        'jurisdictions': value['jurisdictions'],
    };
}
//# sourceMappingURL=NurseLicenseCompactUpdateDto.js.map